/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      stattistik: {
         total: 0,
         year: 0,
         month: 0,
      },
      perBulan: {
         tahun: new Date().getFullYear(),
         data: [],
      },
      jenisProfesi: [],
      fayankes: [],
      jenisKelamin: {
         l: 0,
         p: 0,
      },
      ratioFayankes: [],

   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         commit('SET_TAHUN', selectedYear)
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/mppd/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data && response.data.item
                  ? response.data.item
                  : response.data
               commit('SET_STATISTIK', data || {})

               rootState.isLoading = false
               return data
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      getPerBulan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/mppd/perbulan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_PER_BULAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getJenisProfesi({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/mppd/jenis-profesi`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_JENIS_PROFESI', Array.isArray(data.data) ? data.data : [])

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getFayankes({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/mppd/fayankes`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_FAYANKES', Array.isArray(data.data) ? data.data : [])

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getJenisKelamin({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/mppd/jenis-kelamin`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = (response.data && response.data.data) || {}
               commit('SET_JENIS_KELAMIN', {
                  l: Number(data.l) || 0,
                  p: Number(data.p) || 0,
               })

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getRatioFayankes({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/mppd/ratio-fayankes`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_RATIO_FAYANKES', Array.isArray(data.data) ? data.data : [])

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
   },
   mutations: {

      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         state.stattistik = {
            ...state.stattistik,
            ...data,
         }
      },
      SET_PER_BULAN(state, data) {
         state.perBulan = {
            tahun: data.tahun || state.tahun,
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_JENIS_PROFESI(state, data) {
         state.jenisProfesi = data
      },
      SET_FAYANKES(state, data) {
         state.fayankes = data
      },
      SET_JENIS_KELAMIN(state, data) {
         state.jenisKelamin = {
            l: Number(data.l) || 0,
            p: Number(data.p) || 0,
         }
      },
      SET_RATIO_FAYANKES(state, data) {
         state.ratioFayankes = data
      },

   },
}
